module.exports = __webpack_public_path__ + "img/40_38_037_920.69e18997.jpg";